export const CATEGORIES = {
  COMMON: "Common",
  SIGNING: "Signing",
  FOOTER: "Footer",
  LANDING_PAGE: "Landing Page",
  CONFIRMATION_PAGE: "Confirmation",
  FAQ_PAGE: "FAQ Page",
  PRIVACY_PAGE: "Privacy Page",
  ATTACHMENTS_PAGE: "Attachments Page",
  REPORT_UPDATES_MODAL: "Report Updates Modal",
  PAGE_TWO: "Page Two",
  HEADER: "Header",
};
